const ENDPOINTS = {
  COURSES: '/api/courses',
  FEEDBACKS: '/api/comments',
  USER: '/api/user',
  AUTH: '/api/auth',
  TEST: '/api/language-test',
}

export default ENDPOINTS
